import React, { useContext } from "react";
import { LocalesContext } from "components/LocalesProvider";

export default function useDevice() {
  const { setLocale, locale } = useContext(LocalesContext);

  return { setLocale, locale };
}

